const refType = Symbol('ref')

export interface Ref<T> {
	(): T // Getter
	(value: T): T // Setter
}

export const ref = <T>(get: () => T, set: (v: T) => void): Ref<T> =>
	Object.assign(
		function(v?: T) {
			if (arguments.length) return set(v)
			return get()
		},
		{
			refType
		}
	) as Ref<T>

export const isRef = <T>(check: any): check is Ref<T> =>
	check && check.refType === refType

export const valueRef = <T>(value?: T) => ref(() => value, v => (value = v))

export const arrayRef = <T>(
	initial: ReadonlyArray<T> = []
): Ref<ReadonlyArray<T>> => valueRef(initial)
